import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Form, FormGroup, Label, Input, Card, CardHeader, CardBody, Row, Col, Alert, CustomInput, Badge } from 'reactstrap';
import { Link } from 'react-router-dom';
import { api } from 'api';
import Swal from 'sweetalert2';

class UserPermissions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: null,
            basePermissions: {},
            customPermissions: {},
            loading: true,
            saving: false,
        };
    }

    componentDidMount() {
        const { match } = this.props;
        if (match.params.id) {
            this.loadUser(match.params.id);
        }
    }

    loadUser = async (id) => {
        try {
            const response = await api.get(`user/${id}`);
            const userData = response;

            this.setState({
                user: userData,
                basePermissions: userData.base_permissions || {},
                customPermissions: userData.custom_permissions || {},
                loading: false
            });
        } catch (error) {
            console.error('Error cargando usuario', error);
            this.setState({ loading: false });
        }
    };

    handlePermissionChange = (view, action, value) => {
        const { basePermissions, customPermissions } = this.state;

        const baseValue = basePermissions[view] && basePermissions[view][action];
        const effectiveBase = baseValue === true;

        let newCustom = { ...customPermissions };

        if (!newCustom[view]) newCustom[view] = {};

        if (value === effectiveBase) {
            delete newCustom[view][action];
            if (Object.keys(newCustom[view]).length === 0) {
                delete newCustom[view];
            }
        } else {
            newCustom[view][action] = value;
        }

        this.setState({ customPermissions: newCustom });
    };

    save = async () => {
        const result = await Swal.fire({
            title: '¿Guardar cambios?',
            text: "Se actualizarán los permisos personalizados del usuario. Estos prevalecen sobre el Rol.",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, guardar cambios',
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        this.setState({ saving: true });
        try {
            const { user, customPermissions } = this.state;

            // Only send what we want to update.
            // Sending "...user" sends nested objects (like station: {...}) 
            // which causes backend serializer/model errors.
            await api.put(`user/${user.id}`, {
                custom_permissions: customPermissions
            });

            await Swal.fire(
                'Guardado',
                'Los permisos han sido actualizados correctamente.',
                'success'
            );

            this.props.history.push('/users'); // Go back to users list
        } catch (error) {
            console.error(error);
            Swal.fire('Error', 'Hubo un problema al guardar los permisos.', 'error');
            this.setState({ saving: false });
        }
    };

    getActionLabel = (action) => {
        const labels = {
            view: 'Ver / Listar',
            create: 'Crear',
            edit: 'Editar',
            delete: 'Eliminar'
        };
        return labels[action] || action;
    };

    renderPermissionSection = (view, label, actions = ['view', 'create', 'edit', 'delete']) => {
        const { basePermissions, customPermissions } = this.state;

        const baseView = basePermissions[view] || {};
        const customView = customPermissions[view] || {};

        return (
            <Card className="mb-3">
                <CardHeader className="font-weight-bold bg-light">{label}</CardHeader>
                <CardBody>
                    <Row>
                        {actions.map(action => {
                            const baseVal = baseView[action] === true;
                            const customVal = customView[action];
                            const effectiveVal = customVal !== undefined ? customVal : baseVal;
                            const isModified = customVal !== undefined;

                            // Unique ID for the switch
                            const switchId = `${view}-${action}`;

                            return (

                                <Col md={3} key={action} className="mb-3">
                                    <div className={`p-3 border rounded ${effectiveVal ? 'border-primary' : 'border-light'} ${effectiveVal ? 'bg-white' : 'bg-light'}`}>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <span className="font-weight-bold text-dark">{this.getActionLabel(action)}</span>
                                            <CustomInput
                                                type="switch"
                                                id={switchId}
                                                label=""
                                                checked={effectiveVal}
                                                onChange={(e) => this.handlePermissionChange(view, action, e.target.checked)}
                                            />
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between">
                                            {isModified ? (
                                                <Badge color="info" className="px-2">Personalizado</Badge>
                                            ) : (
                                                <Badge color="secondary" outline className="px-2" style={{ backgroundColor: '#e2e6ea', color: '#6c757d' }}>
                                                    Heredado: {baseVal ? 'Sí' : 'No'}
                                                </Badge>
                                            )}
                                        </div>
                                        {isModified && (
                                            <div className="mt-1 text-right">
                                                <small className="text-muted" style={{ fontSize: '0.75rem' }}>
                                                    {effectiveVal === baseVal ? "(Igual al Rol)" : `(Rol: ${baseVal ? 'Sí' : 'No'})`}
                                                </small>
                                            </div>
                                        )}
                                    </div>
                                </Col>
                            );
                        })}
                    </Row>
                </CardBody>
            </Card>
        );
    };

    render() {
        const { user, loading, saving } = this.state;

        if (loading) return <div className="p-4">Cargando...</div>;
        if (!user) return <div className="p-4">Usuario no encontrado</div>;

        return (
            <div className="container mt-4 pb-5">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                        <h2>Permisos Personalizados</h2>
                        <h5 className="text-muted">Usuario: {user.first_name} {user.last_name} ({user.username})</h5>
                    </div>
                    <div>
                        <Link to="/users" className="btn btn-secondary mr-2">Cancelar</Link>
                        <Button color="primary" onClick={this.save} disabled={saving}>
                            {saving ? 'Guardando...' : 'Guardar Cambios'}
                        </Button>
                    </div>
                </div>

                <Alert color="info">
                    Los cambios realizados aquí anulan los permisos definidos por el Rol ({user.name_role}) y el Perfil de Roles de este usuario.
                    <br />
                    <small>Marcado con <span className="text-primary font-weight-bold">*</span> indica una modificación personalizada.</small>
                </Alert>

                {this.renderPermissionSection('emergencies', 'Emergencias')}
                {this.renderPermissionSection('emergency_types', 'Tipos de Emergencia')}
                {this.renderPermissionSection('vehicles', 'Vehículos')}
                {this.renderPermissionSection('vehicle_types', 'Tipos de Vehículo')}
                {this.renderPermissionSection('users', 'Usuarios')}
                {this.renderPermissionSection('stations', 'Estaciones')}
                {this.renderPermissionSection('reports', 'Reportes', ['view'])}
                {this.renderPermissionSection('roles', 'Gestión de Roles', ['view', 'edit'])}
            </div>
        );
    }
}

export default connect()(UserPermissions);
